<template>
	<div class="layer-project" data-project-name="siliconworks-renewal">
		<!-- Project Name -->
		<div class="layer-project-detail">
			<section class="project-visual">
				<div>
					<h1 class="project-tit">Silicon Works<br />Renewal</h1>
					<!--<a href="http://www.ket.com" class="link" target="_blank">www.ket.com</a>-->
				</div>
			</section>
			<section class="project-overview">
				<img
					src=""
					alt=""
					data-src="/static/img/project-detail/siliconwork-renewal/overview@w.jpg"
				/>
			</section>
			<section class="section01 full">
				<img
					src=""
					alt=""
					data-src="/static/img/project-detail/siliconwork-renewal/section01@w.jpg"
				/>
			</section>
			<section class="section02 full">
				<img
					src=""
					alt=""
					data-src="/static/img/project-detail/siliconwork-renewal/section02-01@w.jpg"
				/>
				<img
					src=""
					alt=""
					data-src="/static/img/project-detail/siliconwork-renewal/section02-02@w.jpg"
				/>
			</section>
			<section class="section02 full">
				<img
					src=""
					alt=""
					data-src="/static/img/project-detail/siliconwork-renewal/section03-01@w.jpg"
				/>
				<img
					src=""
					alt=""
					data-src="/static/img/project-detail/siliconwork-renewal/section03-02@w.jpg"
				/>
			</section>
			<section class="project-client">
				<strong class="a11y-hidden">KET</strong>
			</section>
		</div>

		<app-pjmove></app-pjmove>
	</div>
</template>

<script>
import Swiper from "../../static/js/swiper.min.js"; /* if use swiper.min.js */
import pjMove from "../components/pjMove.vue";
import projectCommon from "../assets/js/projectCommon.js";

export default {
	components: {
		"app-pjmove": pjMove,
	},
	mixins: [projectCommon],
	mounted: function () {
		this.projectInit();

		var isMainListSwiper = false;
		var isMobileMainSwiper = false;
		var isTabletSubSwiper = false;
		var mainListSwiper;
		var mobileMainSwiper;
		var tabletSubSwiper;
		var clear;

		mainListSwiperSet();
		mobileMainSwiperSet();
		tabletSubSwiperSet();

		$(window).on("resize", function () {
			resizeSet();
		});

		function resizeSet() {
			var w = $(window).outerWidth();
			if (w >= 712 && isMainListSwiper) {
				mainListSwiper.destroy();
				isMainListSwiper = false;
			} else {
				mainListSwiperSet();
			}

			if (w >= 712 && isMobileMainSwiper) {
				mobileMainSwiper.destroy();
				isMobileMainSwiper = false;
			} else {
				mobileMainSwiperSet();
			}

			if (w >= 712 && isTabletSubSwiper) {
				tabletSubSwiper.destroy();
				isTabletSubSwiper = false;
			} else {
				tabletSubSwiperSet();
			}
		}

		function mainListSwiperSet() {
			var w = $(window).outerWidth();

			if (isMainListSwiper | (w >= 712)) {
				return;
			}
			isMainListSwiper = true;
			mainListSwiper = new Swiper(".pc-main-visual .swiper-container", {
				slidesPerView: "auto",
				spaceBetween: 0,
				// centeredSlides: true,
				pagination: {
					el: ".pc-main-visual .swiper-pagination",
					clickable: true,
				},
			});
		}

		function mobileMainSwiperSet() {
			var w = $(window).outerWidth();

			if (isMobileMainSwiper | (w >= 712)) {
				return;
			}

			isMobileMainSwiper = true;
			mobileMainSwiper = new Swiper(".mobile-main .swiper-container", {
				slidesPerView: "auto",
				spaceBetween: 0,
				centeredSlides: true,
				loop: true,
				pagination: {
					el: ".mobile-main .swiper-pagination",
					clickable: true,
				},
			});
		}

		function tabletSubSwiperSet() {
			var w = $(window).outerWidth();

			if (isTabletSubSwiper | (w >= 712)) {
				//console.log("return");
				return;
			}
			isTabletSubSwiper = true;
			tabletSubSwiper = new Swiper(".tablet-sub .swiper-container", {
				slidesPerView: "auto",
				spaceBetween: 0,
				centeredSlides: true,
				loop: true,
				pagination: {
					el: ".tablet-sub .swiper-pagination",
					clickable: true,
				},
			});
		}
	},
	methods: {},
};
</script>

<style scoped>
@import "../../static/css/projects.css"; /* Common Project Detail Page */
.project-client {
	background: url(/static/img/project-detail/siliconwork-renewal/ci.gif) 50% /
		auto 41.5px no-repeat;
}

@media screen and (max-width: 711px) {
	.project-visual {
		background-image: url(/static/img/project-detail/siliconwork-renewal/bg-overview@m.jpg);
	}
	.project-visual > div {
		padding-top: 0;
	}
	.project-client {
		background-size: auto 37px;
	}
	.layer-project img {
		width: 100%;
	}
}
@media screen and (min-width: 712px) {
	.project-visual {
		background-image: url(/static/img/project-detail/siliconwork-renewal/bg-overview@t.jpg);
	}
	.project-tit br {
		display: block;
	}
	.project-tit .block {
		display: block;
	}
	.project-client {
		background-size: auto 43px;
	}
}
@media screen and (min-width: 1280px) {
	.project-visual {
		background-image: url(/static/img/project-detail/siliconwork-renewal/bg-overview@w.jpg);
	}
	.project-visual > div {
		padding-top: 0;
	}
	.project-tit br {
		display: block;
	}
	.project-client {
		background-size: auto 67px;
	}
}

.layer-project-detail > section {
	padding: 0;
}
</style>


// WEBPACK FOOTER //
// src/projects/siliconworks-renewal.vue